import api from '@services/api'

export const SET_APP_CONFIG = 'SET_APP_CONFIG'

export const getAppConfig = (callback) => {
    console.log('getAppConfig called')
    return (dispatch) => {
        api.getAppConfig().subscribe(
            (res) => {
                console.log('getAppConfig res', res)
                dispatch(setAppConfig(res.data))
                callback(res.data)
            },
            (err) => console.log('getAppConfig error', err)
        )
    }
}

export const setAppConfig = (appConfig) => ({
    type: SET_APP_CONFIG,
    appConfig,
})

export const setLanguage = (language) => ({
    type: 'SET_LANGUAGE',
    language,
})
